import { inject, Injectable } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { Agreement } from '@monsido/modules/models/api/agreement';
import { Customer } from '@monsido/modules/models/api/customer';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { BehaviorSubject } from 'rxjs';
import { AccountRepoService } from '@client/app/services/api/account-repo/account-repo.service';
import { LocalStorageService } from '@monsido/angular-shared-components';
import { LoginService } from '@client/app/core/services/login/login.service';

@Injectable()
export class CoreAgreementService {
    public hasMultipleAgreements$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    localStorage = inject(LocalStorageService);
    sessionService = inject(SessionService);
    monEventService = inject(MonEventService);
    accountRepo = inject(AccountRepoService);
    loginService = inject(LoginService);

    initAgreements (): void {
        if (this.sessionService.agreements === null) {
            this.sessionService.resetAgreements();
        }
    }

    setAgreements (agreements: Agreement[]): void {
        this.initAgreements();
        this.hasMultipleAgreements$.next(agreements.length > 1);
        this.sessionService.agreements?.next(Object.assign([], agreements));
    }

    clearAgreement (): Promise<void | void[]> {
        this.setAgreements([]);
        this.sessionService.customer = null;
        this.sessionService.agreement = null;
        // HACK: Why do we need this?
        this.localStorage.setItem('roles', [].toString());
        return this.monEventService.run('clearAgreement');
    }

    async setAgreement (agreement: Agreement): Promise<Customer> {
        this.sessionService.agreement = agreement;
        await this.monEventService.run('setAgreement', agreement, this.sessionService.me, this.sessionService.isSudo);
        await this.loginService.reloadUser();
        return this.getAccount();
    }

    async getAccount (): Promise<Customer> {
        return this.accountRepo.get().then((customer: Customer) => {
            this.sessionService.customer = customer;
            return this.monEventService
                .run('setAccount', customer, this.sessionService.agreement, this.sessionService.me, this.sessionService.isSudo)
                .then(() => {
                    return customer;
                });
        });
    }
}
